import script from "./TenantTopBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantTopBar.vue?vue&type=script&setup=true&lang=js"

import "./TenantTopBar.vue?vue&type=style&index=0&id=59340a16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59340a16"]])

export default __exports__